/**
 * Controla o menu que exibe os locations por locationType no mapa.
 *
 * @author: Kete Martins
 * Date: 03/12/13
 * Time: 11:00
 */

import { DefaultRequest } from 'scripts/api';

Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.POISControl = Greenmile.Toolbar.Map.POISControl || {};

Greenmile.Toolbar.Map.POISControl = function (selector, map) {

    this.map = map;
    this.locationTypeSelecteds = [];
    this.colors;

    this.addListeners = async function () {
        await this.getLocationsType(this.poisTypeListRender);
        const checkboxes = document.querySelectorAll(selector + ' .poisList input[type=checkbox]');

        map.on('dragend', () => {
            this.showLocations();
        });

        map.on('zoomend', () => {
            this.showLocations();
        });

        checkboxes.forEach((checkbox) => {
            const checkboxId = checkbox.id.replace(/.+?_/, "");
            checkbox.addEventListener('click', (e) => {
                if (e.target.checked) {
                    this.clearAllPOIsMarker();
                    this.getPoisByType();
                } else {
                    this.clearMarkerByType(checkboxId);
                }
                new Greenmile.Storage.StoreMapPosition().updatePOIs(checkbox);
            });
        });

        this.checkPOIsFromUser(checkboxes);
    };

    this.checkPOIsFromUser = function (listPOISCheckBox) {
        var poisCheckedOnLocalStorage = new Greenmile.Storage.StoreMapPosition().getPOIsMarked();
        var idCheckBox, checked = false;
        if (poisCheckedOnLocalStorage && poisCheckedOnLocalStorage.length > 0) {

            for (var j = 0, sizeEqLS = poisCheckedOnLocalStorage.length; j < sizeEqLS; j++) {

                for (var i = 0; i < listPOISCheckBox.length; i++) {
                    idCheckBox = listPOISCheckBox[i].id.replace(/.+?_/, "");
                    if (poisCheckedOnLocalStorage[j].id.toString() === idCheckBox) {
                        listPOISCheckBox[i].checked = true;
                        checked = true;
                        break;
                    }
                }
            }

            if (checked) {
                this.clearAllPOIsMarker();
                this.getPoisByType();
            }

        }
    };

    this.showLocations = () => {
        const checkedCheckboxes = document.querySelectorAll(selector + " .poisList input[type=checkbox]:checked");
        const savedPOIsList = new Greenmile.Storage.StoreMapPosition().getPOIsMarked();

        if (checkedCheckboxes.length > 0 || (savedPOIsList && savedPOIsList.length)) {
            this.clearAllPOIsMarker();
            this.getPoisByType(savedPOIsList);
        }
    };

    this.getLocationsType = function (callback) {
      const request = new DefaultRequest({
        url: "LocationType/restrictions?criteria={\"filters\":[\"*\", \"organization.*\"]}",
        method: 'post',
        data: {},
        success: function (data) {
          if (data && data.length > 0) {
            Monet.Session.POIs = [];
            Monet.Session.POIs = data;
            const existInLocalStorage = new Greenmile.Storage.StoreMapPosition()
              .getPOIsFromUser();

            if (!existInLocalStorage) {
              const equipmentsToLocalStorage = new Greenmile.Storage.StoreMapPosition().createListPOIs();
              new Greenmile.Storage.StoreMapPosition().setPOIsFromUser(equipmentsToLocalStorage);
            } else {
              new Greenmile.Storage.StoreMapPosition().checkPOIsOnLocalStorage();
            }
          }
          callback(data);
        }
      });
      return request.send();
    };

    this.poisTypeListRender = function (pois) {
        var listUl = selector + " .poisList li ul";
        var poisList = document.querySelector(listUl);
        var templateBase = Greenmile.Toolbar.Map.Layouts["#item_pois_template"];
        const routeReference  = selector.replace(/[^a-zA-Z0-9]/g, "");

        var processedPOIs = {};

        for (var i = 0; i < pois.length; i++) {

            var orgDescription = pois[i].organization.description;
            processedPOIs[orgDescription] = processedPOIs[orgDescription] || [];
            processedPOIs[orgDescription].push(pois[i]);
        }

        if (poisList) {

            for (var org in processedPOIs) {
                var li = document.createElement('li');
                li.className = 'locationTypeOrganizationGroup';
                li.innerHTML = org;
                poisList.appendChild(li);

                var locationTypes = processedPOIs[org];
                
                for (var y in locationTypes) {
                    poisList.appendChild(templateBase(locationTypes[y].id, locationTypes[y].description || locationTypes[y].key, routeReference));
                }
            }

        }

    };

    this.getRandomColor = function () {
        const hexadecimal = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F"];
        let color = "#";
        for (let i = 0; i < 6; i++) {
            color += hexadecimal[Math.floor(Math.random() * hexadecimal.length)];
        }
        return color;
    };

    this.getPoisByType = function (localStoragePOIs) {
        const northLatitude = this.map.getBounds()._northEast.lat;
        const northLongitude = this.map.getBounds()._northEast.lng;
        const southLatitude = this.map.getBounds()._southWest.lat;
        const southLontitude = this.map.getBounds()._southWest.lng;
        const zoomValue = this.map.getZoom();
        const checkedCheckboxes = document.querySelectorAll(selector + ' .poisList input[type=checkbox]:checked');

        if (checkedCheckboxes.length) {
            checkedCheckboxes.forEach((checkbox) => {
                const checkboxId = checkbox.id.replace(/.+?_/, "");
                this.locationTypeSelecteds.push(checkboxId);
            });
        } else if (localStoragePOIs && localStoragePOIs.length) {
            localStoragePOIs.forEach((POI) => {
                this.locationTypeSelecteds.push(POI.id);
            });
        }

        const data = {
            upperRight: { latitude: northLatitude, longitude: northLongitude },
            lowerLeft: { latitude: southLatitude, longitude: southLontitude },
            locationTypeIds: this.locationTypeSelecteds
        };

        if (zoomValue < 15) {
            data.limit = 500;
        }

        const request = new DefaultRequest({
            url: 'Location/FindByBoundingBox',
            method: 'post',
            data,
            success: (data) => {
                const boundLocations = this.bindLocations(data);
                boundLocations.forEach((location) => {
                    this.addMarkersToMap(location.listPOIs, location.id);
                });
                this.locationTypeSelecteds = [];
            }
        });
        request.send();
    };

    this.bindLocations = function (data) {
        var listOFPOIs = [];

        for (var i = 0, size = this.locationTypeSelecteds.length; i < size; i++) {
            var locationTypes = {};
            locationTypes.id = parseInt(this.locationTypeSelecteds[i], 10);
            locationTypes.listPOIs = [];
            for (var j = 0, sizeListData = data.length; j < sizeListData; j++) {
                if (parseInt(this.locationTypeSelecteds[i], 10) === data[j].locationType.id) {
                    locationTypes.listPOIs.push(data[j]);
                }
            }
            if (locationTypes.listPOIs.length > 0) {
                listOFPOIs.push(locationTypes);
            }
        }
        return listOFPOIs;
    };

    this.addMarkersToMap = function (locations, id) {
        var originIcon = '<div style="background-color: rgb(62, 121, 90); width: 7px; height: 7px; border-radius: 3px; border: 1px solid #000;"></div>';
        var listLocations = locations;
        var point = new L.Point(38, 5);
        var colorCluster = this.getRandomColor();
        var colorWithId = {};
        var location, color,
            markers, findID = false;

        colorWithId.id = id;
        colorWithId.color = colorCluster;

        if (typeof (this.colors) !== "undefined") {
            for (var i = 0; i < this.colors.length; i++) {
                color = this.colors[i];
                if (color.id === colorWithId.id) {
                    colorCluster = color.color;
                    findID = true;
                    break;
                }
            }
            if (!findID) {
                this.colors.push(colorWithId);
            }
        } else {
            this.colors = [];
            this.colors.push(colorWithId);
        }


        App.Routers.RouteMonitor.prototype.layerFocus = new L.MarkerClusterGroup({
            maxClusterRadius: 1,
            spiderfyOnMaxZoom: true,
            disableClusteringAtZoom: 2,
            zIndexOffset: 1, 
            spiderfyDistanceMultiplier: 3
        });

        markers = new L.MarkerClusterGroup({
            iconCreateFunction: function (cluster) {
                var count = cluster.getChildCount();
                var clusterSize = "clusterSize_";

                if (count > 0 && count < 10) {
                    clusterSize += 1;
                } else if (count > 0 && count < 100) {
                    clusterSize += 2;
                } else {
                    clusterSize += 3;
                }
                return new L.DivIcon({
                    html: '<b class="locationClusterType ' + clusterSize
                    + '" style="background-color: ' + colorCluster
                    + '">' + cluster.getChildCount() + '</b>'
                });
            }, 
            spiderfyDistanceMultiplier: 3
        });

        markers.clearLayers();
        App.Routers.RouteMonitor.pois = markers;
        map.addLayer(markers);

        var clickOnMarker = function () {
            var that = new Greenmile.Toolbar.Map.POISControl();
            that.showLocationInformation(this.id, map.routeId);
        };

        for (var z in listLocations) {
            location = listLocations[z];
            if (typeof (location.latitude) !== "undefined"
                && typeof (location.longitude) !== "undefined") {

                var marker = L.marker(
                    [location.latitude, location.longitude], {
                        icon: new L.divIcon({
                            html: originIcon,
                            popupAnchor: [-4, 5]
                        })
                    });

                marker.id = location.id;
                marker.on("click", clickOnMarker);
                
                const image = require("static/images/general/loading_blue.svg");
                marker.bindPopup('<div style="height:300px"><img src="' + image + '" width="50" style="margin-left: -25px; margin-top: -25px; left: 50%; position: relative; top: 50%; opacity: 0.5;"></div>', {
                    offset: point,
                    minWidth: 435
                });

                marker.kind = "POI-" + id;
                markers.kind = "POI-CLUSTER-" + id;
                markers.addLayer(marker);
            }
        }
    }.bind(this);

    this.showLocationInformation = function (id, routeId) {

        var query = {
            criteriaChain: []
        };

        query.criteriaChain.push({
            "and": [
                { "attr": "id", "eq": id }
            ]
        });


        const request = new DefaultRequest({
          url: 'Location/restrictions?criteria={"filters":["*"]}',
          method: 'post',
          data: query,
          success: function (data) {
            const location = data[0];

            if (location && typeof (location.latitude) !== "undefined" && typeof (location.longitude) !== "undefined") {
              const str = (new Greenmile.MarkerLocation.GeneralFunctions()).renderPopUpTemplate({
                  id: location.id,
                  labelKey: Monet.I18n.getResourcesByKey('location.key'),
                  key: location.key,
                  labelDescription: Monet.I18n.getResourcesByKey('location.description'),
                  description: location.description,
                  labelAddress1: Monet.I18n.getResourcesByKey('location.address'),
                  address1: location.addressLine1,
                  labelAddress2: Monet.I18n.getResourcesByKey('location.address') + " 2",
                  address2: location.addressLine2,
                  labelDistrict: Monet.I18n.getResourcesByKey('location.district'),
                  district: location.district,
                  labelZipcode: Monet.I18n.getResourcesByKey('location.zip'),
                  zipcode: location.zipcode,
                  labelCity: Monet.I18n.getResourcesByKey('location.city'),
                  city: location.city,
                  labelState: Monet.I18n.getResourcesByKey('location.state'),
                  state: location.state,
                  labelCountry: Monet.I18n.getResourcesByKey('location.country'),
                  country: location.country,
                  labelPhone: Monet.I18n.getResourcesByKey('location.phone1'),
                  phone: location.phone1
              });

              if (typeof routeId !== 'undefined') {
                $("#routeMapContainer_" + routeId + " .leaflet-popup-content").html(str);
              } else {
                if (Monet.Utils.GetTabName() === 'Maps') {
                  $("#mapContainer .leaflet-popup-content").html(str);
                } else {
                  $('#' + Monet.Utils.GetTabName() + ' .leaflet-popup-content').html(str);
                }
              }
              const link = document.querySelector('#Maps #linkToLocation');

              if (link !== null) {
                link.addEventListener('click', function () {
                  if (location !== null) {
                    window.location = "#/Location/edit/" + location.id;
                    new App.Routers.Location().edit(location.id);
                    return false;
                  }
                });
              }
            }
          }
        });
        request.send();
    };

    this.clearMarkerByType = function (idType) {
        var markers;
        markers = map._layers;
        for (var key in markers) {
            if (typeof (markers[key]) !== "undefined") {
                if (markers[key].kind === ("POI-" + idType)) {
                    map.removeLayer(markers[key]);
                } else if (markers[key].kind === "POI-CLUSTER-" + idType) {
                    map.removeLayer(markers[key]);
                }
            }
        }
    };

    this.clearAllPOIsMarker = function () {
        var markers, markerPOIs;
        markers = map._layers;
        for (var key in markers) {
            if (typeof (markers[key]) !== "undefined" && markers[key].kind) {
                markerPOIs = markers[key].kind.toString();
                if (markerPOIs.indexOf("POI-") !== -1) {
                    map.removeLayer(markers[key]);
                }
            }
        }
    };

};
